import React, { useState } from "react";
import Select from "react-select";
import client from "../../../shared/api/client";
import darkSelectStyles from "../../../shared/darkSelectStyles";
import { toastSuccess, toastError } from "../../../shared/toastHelper";

const MetaAdsFinanceMapping = ({
  csrfToken,
  metaAdsAccessId,
  financeCategories = [],
  financeCategoryId,
  financeLineItemDescription,
}) => {
  const [categoryId, setCategoryId] = useState(financeCategoryId ? String(financeCategoryId) : "");
  const [description, setDescription] = useState(financeLineItemDescription || "");
  const [submitting, setSubmitting] = useState(false);

  const categoryOptions = financeCategories.map((c) => ({ value: String(c.id), label: c.name }));
  const selectedCategory = categoryOptions.find((o) => o.value === categoryId) || null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await client.patch(`/meta_ads_accesses/${metaAdsAccessId}`, {
        authenticity_token: csrfToken,
        finance_mapping: {
          finance_category_id: categoryId,
          finance_line_item_description: description,
        },
      });
      toastSuccess("Finance mapping saved.");
    } catch {
      toastError("Failed to save finance mapping. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="col-12 col-md-8 offset-md-2">
      <div className="card mt-4 shadow-3">
        <div className="card-body">
          <h4><strong>Opendate finance category</strong></h4>
          <p className="text-muted">
            On each nightly sync, total Meta Ads spend is pushed to a finance line item
            under this category. Leave unset to use the default <strong>Marketing</strong> category.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="meta-ads-finance-category">Finance category</label>
              <Select
                inputId="meta-ads-finance-category"
                classNamePrefix="meta-ads-finance-category"
                styles={darkSelectStyles}
                options={categoryOptions}
                value={selectedCategory}
                onChange={(option) => setCategoryId(option ? option.value : "")}
                isClearable
                placeholder="Default (Marketing)"
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              />
            </div>
            <div className="form-group">
              <label htmlFor="meta-ads-finance-description">
                Update existing line item by description (optional)
              </label>
              <input
                id="meta-ads-finance-description"
                type="text"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <small className="text-muted">
                If an event already has a finance line item in the category above with this exact
                description, the sync updates that line in place (and relabels it) instead of adding
                a second one. Leave blank to use the default “Meta Ads” description.
              </small>
            </div>
            <button type="submit" className="btn btn-setlist-primary" disabled={submitting}>
              {submitting ? "Saving..." : "Save"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MetaAdsFinanceMapping;
